import * as React from 'react';
import { MapRouteButton } from '../../../../components/Map/parts';

export interface IRouteButtonContainerProps {
  visible: boolean;
  onRoutingClick?(): void;
}

export const RouteButtonContainer: React.FC<IRouteButtonContainerProps> = props => {
  const { visible, onRoutingClick } = props;

  if (!visible) {
    return null;
  }

  return <MapRouteButton onClick={onRoutingClick} />;
};
